module.exports = __webpack_public_path__ + "static/img/banner.cce2355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/banner.png
// module id = MjzT
// module chunks = 1